export type Values = {
  name: string
  password: string
  email: string
  'marketing-consent': boolean
}

export const SIGN_UP_INITIAL_VALUES: Values = {
  name: '',
  password: '',
  email: '',
  'marketing-consent': false,
}
